import { createFileRoute } from "@tanstack/react-router";
import { ArquivosPage } from "@/pages/ArquivosPage";

export const Route = createFileRoute("/arquivos/")({
  head: () => ({ meta: [{ title: "Arquivos — AXIS Comprovantes" }] }),
  component: ArquivosPage,
});
